/**
 * Upcoming Matches Page
 * Dedicated page for viewing upcoming matches
 * Works for both club users and partner users
 * Automatically filters by user's preferred club
 */

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePartnerAuth } from '../contexts/PartnerAuthContext';
import UpcomingMatchesDashboard from '../components/sports/UpcomingMatchesDashboard';

const UpcomingMatches: React.FC = () => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const { user: partnerUser } = usePartnerAuth();
  const navigate = useNavigate();
  const [isReady, setIsReady] = useState(false);

  // Wait for auth to fully load before checking or showing content
  useEffect(() => {
    console.log('UpcomingMatches - Auth state:', {
      isLoading,
      isAuthenticated,
      partnerUser: !!partnerUser,
      preferredClubId: user?.preferredClubId
    });

    // Don't do anything while auth is still loading
    if (isLoading) {
      return;
    }

    // Auth has finished loading
    if (!isAuthenticated && !partnerUser) {
      console.log('UpcomingMatches - No user authenticated, redirecting to home');
      navigate('/');
    } else {
      console.log('UpcomingMatches - User authenticated with preferredClubId:', user?.preferredClubId);
      setIsReady(true);
    }
  }, [isLoading, isAuthenticated, partnerUser, navigate, user?.preferredClubId]);

  // Show loading while auth is loading or not ready
  if (isLoading || !isReady) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Loading...</div>
      </div>
    );
  }

  // Use user's preferred club ID for filtering (if set)
  const preferredClubId = user?.preferredClubId;

  console.log('UpcomingMatches - Rendering with preferredClubId:', preferredClubId);

  return (
    <div className="page-container" style={{ padding: '0' }}>
      <UpcomingMatchesDashboard
        daysAhead={1000}
        maxMatches={1000}
        showHeader={true}
        clubId={preferredClubId}
      />
    </div>
  );
};

export default UpcomingMatches;

